/**
 * 根據環境返回正確的 API baseURL
 * 開發環境使用相對路徑（透過 proxy），生產環境使用完整 URL
 *
 * @returns {string} API baseURL
 */
export function getApiBaseURL() {
  if (process.env.ENV === 'development') {
    // 開發環境：使用相對路徑，透過 webpack-dev-server proxy 轉發
    return '/api';
  }
  // 生產環境：使用完整 URL
  return process.env.VUE_APP_BASE_API;
}
